module.exports = __webpack_public_path__ + "img/tutorial-quickstart-thumb.3d32d41b.png";